import {useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const AddToCartButton = ({totalAmount, triggerClick}) => {
    const cartBtnRef = useRef(null);
    const [clicked, setClicked] = useState(false);
    const navigate = useNavigate("")

    useEffect(() => {
        if (triggerClick) {
            setClicked(true);
            setTimeout(() => {
                setClicked(false);
            }, 3000);
        }
    }, [triggerClick]);

    return (
        <div className="add-to-cart-div-animate">
            <button
                ref={cartBtnRef}
                className={`add-to-cart-button-animate ${clicked ? "clicked" : ""}`}
            >
                <span className="add-to-cart-button-text2-animate">Added</span>
                <i className="fa-solid fa-cart-shopping add-to-cart-button-icon1-animate"></i>
                <i className="fa-solid fa-box add-to-cart-button-icon2-animate"></i>
                <span className="add-to-cart-button-text1-animate"><span className="fixed-div-total-amount">₹{totalAmount}</span> <span className="fixed-div-view-more" onClick={() => navigate('/cart')} // Directly using an inline function
                        style={{ cursor: 'pointer' }}>View cart</span></span>
            </button>
        </div>
    );
};

export default AddToCartButton;
